import { Col, Row } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

import { EditSelect } from 'components/forms/EditSelect';
import type { EditSelectOptionList } from 'components/forms/EditSelect';

import type { EditableSchedule } from './EditableSchedule';
import { DAY_OF_WEEK_OPTIONS } from './scheduleFieldOptions';

export interface ScheduleRuleFieldOptions {
  readonly month: EditSelectOptionList<number | null>;
  readonly week: EditSelectOptionList<number | null>;
  readonly nth: EditSelectOptionList<number | null>;
}

interface Props {
  readonly schedule: EditableSchedule;
  readonly unit: 'period' | 'month';
  readonly opts: ScheduleRuleFieldOptions;
}

/**
 * From/until period-or-month, week-of-unit, and day-of-week fields for one rule.
 */
export const ScheduleRulePeriodFields = observer<Props>(({ schedule, unit, opts }) => (
  <>
    <Row className="mb-3">
      <Col md={6}>
        <EditSelect<number | null> label={`From ${unit}`} value={schedule.monthFrom} onChange={(v) => (schedule.monthFrom = v)} options={opts.month} />
      </Col>
      <Col md={6}>
        <EditSelect<number | null> label={`Until ${unit}`} value={schedule.monthUntil} onChange={(v) => (schedule.monthUntil = v)} options={opts.month} />
      </Col>
    </Row>

    <Row className="mb-3">
      <Col md={6}>
        <EditSelect<number | null>
          label={`From week of ${unit}`}
          value={schedule.weekOfMonthFrom}
          onChange={(v) => (schedule.weekOfMonthFrom = v)}
          options={opts.week}
        />
      </Col>
      <Col md={6}>
        <EditSelect<number | null>
          label={`Until week of ${unit}`}
          value={schedule.weekOfMonthUntil}
          onChange={(v) => (schedule.weekOfMonthUntil = v)}
          options={opts.week}
        />
      </Col>
    </Row>

    <Row className="mb-3">
      <Col md={6}>
        <EditSelect<number | null>
          label="From day of week"
          value={schedule.dayOfWeekFrom}
          onChange={(v) => (schedule.dayOfWeekFrom = v)}
          options={DAY_OF_WEEK_OPTIONS}
        />
      </Col>
      <Col md={6}>
        <EditSelect<number | null>
          label="Until day of week"
          value={schedule.dayOfWeekUntil}
          onChange={(v) => (schedule.dayOfWeekUntil = v)}
          options={DAY_OF_WEEK_OPTIONS}
        />
      </Col>
    </Row>
  </>
));
